import icon from "~/assets/icon.png";

interface LoaderProperties {
  size?: number;
}

export default function Loader({ size = 4 }: LoaderProperties) {
  return (
    <img
      src={icon}
      alt="Hermansbar"
      className="animate-spin drop-shadow-glow"
      style={{ width: `${size}rem`, height: `${size}rem` }}
    />
  );
}